export const LOAD_PROJECTS = 'LOAD PROJECTS';

export function loadProjects(projects) {
  return {
    type: LOAD_PROJECTS,
    projects,
  }
}
